import React from "react";

import { useArrival } from "../../hooks/useArrival/useArrival";

import { Direction } from "./../Direction/Direction";

/*
 * расписание прилётов
 */
export const Arrival = () => {
  const [data, loading] = useArrival(window.cityCode);

  //   console.log(data);

  let schedules =
    data && data.map((elem, i) => <Direction schedule={elem} key={i} />);

  return (
    <>
      {/* <h2>Прилёты</h2> */}
      {data && schedules}
      {loading && <div>loading...</div>}
    </>
  );
};
